import { toast } from 'react-toastify';

/** Copies text and confirms with a toast (`successMessage`, default "Copied"; "Couldn't copy" on failure). */
export async function copyText(text, successMessage = 'Copied') {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(successMessage);
  } catch {
    toast.error("Couldn't copy");
  }
}
